import { SelectionChangedEvent } from "ag-grid-community";
import { BillToCompanyMappingEntity } from "domain/entity/BillToCompanyMapping/BillToCompanyMappingEntity";
import _ from "lodash";
import { INITIAL_BILL_TO_COMPANY_MAPPING_COL_DEF } from "presentation/constant/BillToCompanyMapping/BillToCompanyMappingColumnDefinition";
import { BillToCompanyMappingConstant } from "presentation/constant/BillToCompanyMapping/BillToCompanyMappingConstant";
import { useBillToCompanyMappingVM } from "presentation/hook/BillToCompanyMapping/useBillToCompanyMappingVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { useBillToCompanyMappingTracked } from "presentation/store/BillToCompanyMapping/BillToCompanyMappingProvider";
import RightClickMenuWithMoveAfter from "presentation/view/components/NbisRightClickMenu/RightClickMenuWithMoveAfter";
import NbisTable from "presentation/view/components/TableWrapper/NbisTable";
import { TableWrapper } from "presentation/view/components/TableWrapper/TableWrapper";
import { createRef, memo, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Loader } from "veronica-ui-component/dist/component/core";
const BillToCompanyMappingTablePanel = () => {
    const gridRef: any = useRef(null);
    const [billToCompanyMappingState] = useBillToCompanyMappingTracked();
    const billToCompanyMappingVM = useBillToCompanyMappingVM();
    const messageBarVM = useMessageBarVM();

    // const [onTableSelectionClicked, setOnTableSelectionClicked] = useState<boolean>(false);
    const [anainfoState] = useANAInfoTracked();
    const { allowUpdate, allowCreate } = anainfoState;
    const rightClickRef: any = createRef();
    // for right click menu with move after begin
    const [showMoveCursor, setShowMoveCursor] = useState<boolean>(false);
    const [allRows, setAllRows] = useState<BillToCompanyMappingEntity[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [initialAllRows, setInitialAllRows] = useState<boolean>(true);

    const getAllRows = useCallback(() => {
        return allRows;
    }, [allRows]);

    const getSelectedRows = useCallback(() => {
        return billToCompanyMappingState.selectedRows;
    }, [billToCompanyMappingState.selectedRows]);

    // const getShowMoveCursor = useCallback(() => {
    //     return showMoveCursor;
    // }, [showMoveCursor]);
    //for right click menu with move after end

    // useEffect(() => {
    //     //const columnDefs = (INITIAL_BILL_TO_COMPANY_MAPPING_COL_DEF?.slice());

    //     if (!billToCompanyMappingState.selectedRows || billToCompanyMappingState.selectedRows.length <= 0) {
    //         //gridRef.current?.gridRef.current.api?.setColumnDefs(columnDefs);
    //         if (!onTableSelectionClicked) {
    //             gridRef.current?.gridRef.current.api?.deselectAll();
    //         }
    //     }
    //     changeCursor("bill-to-company-mapping-table", getShowMoveCursor());
    // });

    // useEffect(() => {
    //     if (!onTableSelectionClicked) return;
    //     gridRef?.current?.gridRef.current.api?.deselectAll();
    //     changeCursor("bill-to-company-mapping-table", getShowMoveCursor());
    // }, [getShowMoveCursor, onTableSelectionClicked]);



    const handleSelectionChange = useCallback((e: SelectionChangedEvent) => {
        // setOnTableSelectionClicked(true);
        const selectedRows = e.api.getSelectedRows();
        billToCompanyMappingVM.updateSelectedRows(selectedRows);
    }, [billToCompanyMappingVM])

    // const handleRowDrag = useCallback((e: any, updatedRows: BillToCompanyMappingEntity[], movedIndex: number, overIndex: number)=>{
    //     billToCompanyMappingVM.onRowDrag(updatedRows);
    // },[billToCompanyMappingVM])


    useEffect(() => {
        const handleRightClickMenu = (event: any) => {
            if (_.isEmpty(billToCompanyMappingState.selectedRows) || !allowUpdate) {
                return;
            }
            event.preventDefault();
            rightClickRef.current.show(event);
        };
        document.getElementById('myDiv')?.addEventListener("contextmenu", handleRightClickMenu);

        return () => {
            document.getElementById('myDiv')?.removeEventListener("contextmenu", handleRightClickMenu);
        };
    }, [messageBarVM, rightClickRef, allowUpdate, billToCompanyMappingState.selectedRows]);

    // for right click menu with move after begin
    const onRefreshRow = useCallback((newAllRows: any[]) => {
        setAllRows(newAllRows);
        billToCompanyMappingVM.updateSelectedRows([]);
        setShowMoveCursor(true);
    }, [billToCompanyMappingVM]);

    const onMoveCancel = useCallback(() => {
        setInitialAllRows(true);
        setAllRows(billToCompanyMappingState.billToCompanyMappingList);
        billToCompanyMappingVM.updateSelectedRows([]);
        setShowMoveCursor(false);
    }, [billToCompanyMappingState.billToCompanyMappingList, billToCompanyMappingVM]);

    const handleRowDoubleClick = useCallback((entity: BillToCompanyMappingEntity) => {
        // if(updatedRows.length > 0){
        //     messageBarVM.showError("Modified data has not been saved.Please save or refersh the data first."); 
        //     return;
        // }
        billToCompanyMappingVM.onRowDoubleClick(entity);
    }, [billToCompanyMappingVM])

    const onSaveMove = useCallback(async (newAllRows: any[]) => {
        if (_.isEmpty(newAllRows)) return;

        setIsLoading(true);

        billToCompanyMappingVM.onApply(newAllRows).then((res) => {
            if (!res || !res.success) {
                messageBarVM.showError('Move failed.');
                setInitialAllRows(true);
                setIsLoading(false);

                billToCompanyMappingVM.updateSelectedRows([]);
                setShowMoveCursor(false);
            } else {
                billToCompanyMappingVM.searchAllBillToCompanyMappingList().then((data) => {
                    setInitialAllRows(true);
                    setIsLoading(false);

                    billToCompanyMappingVM.updateSelectedRows([]);
                    setShowMoveCursor(false);
                }).catch((e) => {
                    setInitialAllRows(true);
                    setIsLoading(false);

                    billToCompanyMappingVM.updateSelectedRows([]);
                    setShowMoveCursor(false);
                })
            }
        })
    }, [messageBarVM, billToCompanyMappingVM]);

    const handleAddClick = useCallback(() => {
        billToCompanyMappingVM.onAddClick();
    }, [billToCompanyMappingVM]);


    const memoBillToCompanyMappingTable = useMemo(() => {

        return (
            <>
                {(allowUpdate) && <RightClickMenuWithMoveAfter disabled={_.isEmpty(getSelectedRows())}
                    rightClickRef={rightClickRef} selectedRows={getSelectedRows()} allRows={getAllRows()}
                    onSaveMove={onSaveMove} onCancel={onMoveCancel} onRefreshRow={onRefreshRow}
                    showConfirmMove={showMoveCursor} priorityName="priority" />}
                <div id="myDiv">
                    <NbisTable
                        id='bill-to-company-mapping-table'
                        isNewColumnSetting={true}
                        headerLabel={BillToCompanyMappingConstant.Title.TITLE}
                        columns={INITIAL_BILL_TO_COMPANY_MAPPING_COL_DEF}
                        data={allRows ?? []}
                        showPaginator={false}
                        editable={false}
                        showAddIcon={allowCreate}
                        showDeleteButton={false}
                        showReloadIcon={false}
                        isScrollHighlighted={true}
                        selectionMode={false}
                        isRowHighligted={true}
                        handleSelectionChanged={handleSelectionChange}
                        onRowDoubleClick={(e: any, entity: BillToCompanyMappingEntity) => handleRowDoubleClick(entity)}
                        gridHeight="customHeight"
                        customHeight="calc(100vh - 75px)"
                        ref={gridRef}
                        rowSelection={showMoveCursor ? "single" : "multiple"}
                        // isRowDrag={true}
                        // onRowDragged={handleRowDrag}
                        // onBodyScroll={(e: any) => changeCursor("bill-to-company-mapping-table", getShowMoveCursor())}
                        onAddClick={handleAddClick}
                        showCutCursor={showMoveCursor}
                    />
                </div>
            </>
        );
    }, [allowCreate, allRows, allowUpdate, getAllRows, getSelectedRows, handleRowDoubleClick, handleSelectionChange, onMoveCancel, onRefreshRow, onSaveMove, rightClickRef, showMoveCursor, handleAddClick])

    useEffect(() => {
        if (initialAllRows && billToCompanyMappingState.billToCompanyMappingList && !_.isEmpty(billToCompanyMappingState.billToCompanyMappingList)) {
            setAllRows(billToCompanyMappingState.billToCompanyMappingList.map((billToCompanyMappingEntity, index) => ({
                ...billToCompanyMappingEntity,
                index: index || 0
            })));
            setInitialAllRows(false);
        }
    }, [allRows, initialAllRows, billToCompanyMappingState.billToCompanyMappingList]);

    return <><TableWrapper>
        {(isLoading) && <Loader Indicator="Spinner" size="Medium" />}
        {memoBillToCompanyMappingTable}
        {billToCompanyMappingState.forceRefresh && <></>}
    </TableWrapper>
    </>;
}

export default memo(BillToCompanyMappingTablePanel);
